import React, { useEffect } from 'react';
import { Snackbar, Alert, AlertColor, IconButton, Badge } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useNotifications } from '../../contexts/NotificationContext';

/**
 * Global toast notification component
 * Displays temporary notifications at the bottom-right of the screen
 */
export const NotificationToast: React.FC = () => {
  const { toast, closeToast } = useNotifications();

  useEffect(() => {
    if (toast) {
      // Auto-close after 5 seconds
      const timer = setTimeout(() => {
        closeToast();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [toast, closeToast]);

  if (!toast) return null;

  return (
    <Snackbar
      open={true}
      onClose={closeToast}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ mb: 2, mr: 2 }}
    >
      <Alert
        onClose={closeToast}
        severity={toast.type as AlertColor}
        variant="filled"
        sx={{ 
          width: '100%',
          minWidth: 300,
          boxShadow: 3,
        }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={closeToast}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationToast;
